<template>
  <div>
      <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
              <li class="breadcrumb-item" @click="$router.push('/admon')" style="cursor: pointer">Administración</li>
              <li class="breadcrumb-item active" aria-current="page">Notificaciones</li>
          </ol>
      </nav>
      <div class="container-fluid">
          <div class="row" style="margin-top:20px;">
              <div class="col-md-12">
                  <vs-card>
                      <template slot="header">
                        <div class="flex">
                          <h2 class="flex-1">Notificaciones</h2>
                          <div>
                            <div class="flex">
                            <vs-button class="mr-2" v-on:click="showModal('reporte')">Reporte</vs-button>
                            <vs-button
                                icon="add"
                                style="background-color: green; float: right"
                                v-on:click="showModal('notificacion')">
                            </vs-button>
                            </div>
                          </div>
                        </div>
                      </template>

                      <vs-table :data="data" v-if="data !== null">
                          <template slot="thead">
                              <vs-th>ID</vs-th>
                              <vs-th>Categoría</vs-th>
                              <vs-th>Event code</vs-th>
                              <vs-th>Nombre</vs-th>
                              <vs-th>Descripción</vs-th>
                              <vs-th>Inversionista</vs-th>
                              <vs-th>Solicitante</vs-th>
                              <vs-th>Proveedores</vs-th>
                              <vs-th>Acción</vs-th>
                          </template>
                          <vs-tr v-for="renglon in data" :key="renglon.id">
                              <vs-td>{{renglon.id}}</vs-td>
                              <vs-td>{{renglon.category === 0 ? 'No definido':''}}</vs-td>

                              <vs-td>{{renglon.event_code}}</vs-td>
                              <vs-td>{{renglon.name}}</vs-td>
                              <vs-td>{{renglon.description}}</vs-td>

                              <vs-td style="text-align: center">
                                  <em class="material-icons" v-if="renglon.for_investors" style="color: green">check_circle</em>
                                  <em class="material-icons" v-else>panorama_fish_eye</em>
                              </vs-td>
                              <vs-td style="text-align: center">
                                  <em class="material-icons" v-if="renglon.for_clients" style="color: green">check_circle</em>
                                  <em class="material-icons" v-else>panorama_fish_eye</em>
                              </vs-td>
                              <vs-td style="text-align: center">
                                  <em class="material-icons" v-if="renglon.for_suppliers" style="color: green">check_circle</em>
                                  <em class="material-icons" v-else>panorama_fish_eye</em>
                              </vs-td>
                              <vs-td style="cursor: pointer">
                                  <vs-button icon="edit" v-on:click="showModal('editar', renglon)">
                                  </vs-button>
                              </vs-td>
                          </vs-tr>
                      </vs-table>
                  </vs-card>
              </div>
          </div>
      </div>

      <vs-popup :active.sync="showNotification" :title="accion === 1 ? 'Agregar Notificación' : 'Editar Notificación'">
          <vs-card style="overflow-y: auto; padding: 3%">
            <vs-select label="Categoría" v-model="category">
              <vs-select-item value="0" text="No Definido"></vs-select-item>
            </vs-select>
            <vs-textarea class="mt-1" label="Nombre" v-model="name"></vs-textarea>
            <vs-input class="mt-1" label="Event Code" v-model="event_code"></vs-input>
            <vs-textarea class="mt-1" label="Descripción" v-model="description"></vs-textarea>
            <vs-checkbox class="mt-1" v-model="visible">Visible</vs-checkbox>
            <vs-checkbox class="mt-1" v-model="for_investors"> Inversionistas</vs-checkbox>
            <vs-checkbox class="mt-1" v-model="for_clients">Solicitantes</vs-checkbox>
            <vs-checkbox class="mt-1" v-model="for_suppliers">Proveedores</vs-checkbox>
            <vs-checkbox class="mt-1" v-model="on_off_default">Activo por default</vs-checkbox>
          </vs-card>
          <div class="mt-6">
              <vs-button class="mr-2" @click="validar()">Guardar</vs-button>
              <vs-button color="dark" @click="hideModal('notificacion')">Cerrar</vs-button>
          </div>
      </vs-popup>

      <vs-popup :active.sync="showReporte" title="Reporte">
          <vs-card>
            <vs-table :data="[{}]">
                <template slot="thead">
                    <vs-th style="text-align: left!important">ID</vs-th>
                    <vs-th style="text-align: left!important">Categoría</vs-th>
                    <vs-th style="text-align: left!important">ID Correo</vs-th>
                    <vs-th style="text-align: left!important">Nombre</vs-th>
                    <vs-th>Visible</vs-th>
                </template>
                <vs-tr v-for="renglon in data" :key="renglon.id">
                    <vs-td style="font-weight: bold !important;">{{renglon.id}}</vs-td>
                    <vs-td style="text-align: center">{{renglon.category === 0 ? 'No definido':''}}</vs-td>

                    <vs-td style="text-align: center">{{renglon.event_code}}</vs-td>
                    <vs-td>{{renglon.name}}</vs-td>
                    <vs-td style="text-align: center">
                        <label class="container">
                            <input class="limpiar" type="checkbox" v-model="renglon.visible" disabled>
                            <span class="checkmark" style="margin-top:-10px!important;"/>
                        </label>
                    </vs-td>
                </vs-tr>
            </vs-table>

            <vs-divider />

            <vs-table :data="[{}]">
              <template slot="thead">
                <vs-th></vs-th>
                <vs-th colspan="3" style="text-align: center !important">Universo</vs-th>
                <vs-th colspan="3" style="text-align: center !important">Alcance</vs-th>
                <vs-th colspan="3" style="text-align: center !important">Activos</vs-th>
                <vs-th style="text-align: left!important">ID</vs-th>
                <vs-th>Inversionistas</vs-th>
                <vs-th>Solicitantes</vs-th>
                <vs-th>Proveedores</vs-th>
                <vs-th>Inversionistas</vs-th>
                <vs-th>Solicitantes</vs-th>
                <vs-th>Proveedores</vs-th>
                <vs-th>Inversionistas</vs-th>
                <vs-th>Solicitantes</vs-th>
                <vs-th>Proveedores</vs-th>
              </template>
                <vs-tr v-for="renglon in data" :key="renglon.id">
                    <vs-td style="font-weight: bold !important;">{{renglon.id}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.investorsUniverse)}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.clientsUniverse)}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.suppliersUniverse)}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.investorScope)}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.clientScope)}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.supplierScope)}}</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.investorActive,2)}}%</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.clientActive,2)}}%</vs-td>
                    <vs-td style="text-align: center">{{format_price(renglon.supplierActive,2)}}%</vs-td>
                </vs-tr>
              </vs-table>
          </vs-card>
          <div class="mt-6">
              <vs-button color="dark" @click="hideModal('reporte')">Cerrar</vs-button>
          </div>
      </vs-popup>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'notificaciones',
    props: [],
    mounted() {
      this.getNotifications();
    },
    data() {
      return {
        data: [],
        accion: 0,

        showNotification: false,
        showReporte:false,

        id: 0,
        category: 0,
        event_code: '',
        name: '',
        description: '',
        visible: true,
        for_clients: false,
        for_investors: false,
        for_suppliers: false,
        on_off_default: true,
      }
    },
    methods: {
      getNotifications(){
        axios.get( '/api/notifications').then(response => {
          this.data = response.data.data;
        });
      },
      editar(notification){
        this.accion=2;
        this.id = notification.id;
        this.category = notification.category;
        this.event_code = notification.event_code;
        this.name = notification.name;
        this.description = notification.description;
        this.visible = notification.visible;
        this.for_clients = notification.for_clients;
        this.for_investors = notification.for_investors;
        this.for_suppliers = notification.for_suppliers;
        this.on_off_default = notification.on_off_default;
      },
      agregar(){
        this.accion=1;
        this.id = 0;
        this.category = 0;
        this.event_code = '';
        this.name = '';
        this.description = '';
        this.visible = true;
        this.for_clients = false;
        this.for_investors = false;
        this.for_suppliers = false;
        this.on_off_default = true;
      },
      validar(){
        if(this.name==''){
          Vue.toasted.show('Escribe un nombre para la notificación! ', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000})
        }else if(this.for_clients==false && this.for_investors==false && this.for_suppliers==false){
          Vue.toasted.show('Selecciona al menos uno de lo siguientes: Inversionista, Cliente o Proveedor.', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000})
        }else{
          this.guardar();
        }
      },
      async guardar(){
        this.$vs.loading();
        Vue.toasted.clear();
        Vue.toasted.show('Guardando notificación...', { position: 'bottom-center', closeOnSwipe: false });
        await axios.post( '/api/notification/save', {
          id: this.id,
          category: this.category,
          event_code: this.event_code,
          name: this.name,
          description: this.description,
          visible: this.visible,
          for_clients: this.for_clients,
          for_investors: this.for_investors,
          for_suppliers: this.for_suppliers,
          on_off_default: this.on_off_default,
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Notificación guardada !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          this.getNotifications();
          this.hideModal('notificacion')
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('¡ERROR! Algo salió mal...', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
        this.$vs.loading.close();
      },
        showModal(destino, renglon=null){
            if(destino==="notificacion"){
                this.agregar();
                this.showNotification = true;
            }

            if(destino==="editar"){
                this.editar(renglon);
                this.showNotification = true;
            }

            if(destino==="reporte"){
                this.showReporte = true;
            }
        },
        hideModal(destino){
            if(destino==="notificacion"){
                this.showNotification = false;
            }

            if(destino==="reporte"){
                this.showReporte = false;
            }
        },

        format_price(value,decimales=0) {
            let val = (value/1).toFixed(decimales).replace(',', '.');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
}
</script>
<style scoped>
/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.limpiar{
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: rgb(243, 205, 33);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
